export default {
  DEFAULT: 'default',
  DENIED: 'denied',
  GRANTED: 'granted',
};
